import { render, staticRenderFns } from "./ActForm.vue?vue&type=template&id=189af38e&scoped=true"
import script from "./ActForm.vue?vue&type=script&lang=js"
export * from "./ActForm.vue?vue&type=script&lang=js"
import style0 from "./ActForm.vue?vue&type=style&index=0&id=189af38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189af38e",
  null
  
)

export default component.exports